
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sde",
      function () {
        return require("private-next-pages/sde.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sde"])
      });
    }
  